export default __webpack_public_path__ + "static/international-yards-desktop-27ff915c89e0be8e65c79b523ace640e.svg";